import { isSoundOn, setSoundOn, loadAudio } from '../lib/audio.js';

export function mountSoundToggle(el) {
  el.setAttribute('data-test', 'sound-toggle');
  const update = () => { el.textContent = isSoundOn() ? '🔊' : '🔈'; };
  update();
  el.addEventListener('click', () => {
    const next = !isSoundOn();
    setSoundOn(next);
    if (next) loadAudio();
    update();
  });
}
